__turbopack_context__.v({
  "actions": "individual-subscription-notice-module-scss-module__MH6DDq__actions",
  "btn": "individual-subscription-notice-module-scss-module__MH6DDq__btn",
  "content": "individual-subscription-notice-module-scss-module__MH6DDq__content",
  "copyIconBtn": "individual-subscription-notice-module-scss-module__MH6DDq__copyIconBtn",
  "decor": "individual-subscription-notice-module-scss-module__MH6DDq__decor",
  "description": "individual-subscription-notice-module-scss-module__MH6DDq__description",
  "emailCopyBtn": "individual-subscription-notice-module-scss-module__MH6DDq__emailCopyBtn",
  "mail": "individual-subscription-notice-module-scss-module__MH6DDq__mail",
  "root": "individual-subscription-notice-module-scss-module__MH6DDq__root",
  "title": "individual-subscription-notice-module-scss-module__MH6DDq__title",
});
